<template>
  <div>
    <van-tabs
      v-model="active"
      :line-width="56"
      title-active-color="#991D85"
      @click="onClick"
    >
      <van-tab v-for="(item, index) in tabs" :title="item.label" :key="index">
        <div
          class="tabChildBox"
          v-show="swiperTypeList && swiperTypeList.length > 0"
        >
          <div class="flex-c swiperBox">
            <div class="scroll-container notScroll">
              <div class="scroll-wrapper" :class="{ 'scrollType2': active == 1  }">
                <div
                  class="scroll-item __line1"
                  :class="{ active: selectedIndex === index }"
                  v-for="(sItem, index) in swiperTypeList"
                  :key="sItem.id"
                  @click="selectSlide(index, sItem)"
                >
                  {{ sItem.name }}
                </div>
              </div>
            </div>
            <div
              class="moreIcon"
              @click="show = true"
              v-if="swiperTypeList.length > 3"
            >
            
            </div>
          </div>
        </div>
        <div class="moreText" @click="moreListHandle" v-if="isShowMore()">
          查看更多 >>
        </div>
      </van-tab>
    </van-tabs>
    <van-popup v-model="show" position="right" get-container="#app">
      <div class="popupContent">
        <div class="title">行业分类</div>
        <div class="list">
          <ul>
            <li
              @click="popItemHandle(index, item)"
              class="item"
              v-for="(item, index) in items"
              :key="index"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="closePop" @click="show = false">返回</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    tabs: [Array, Object],
    showMore: {
      type: Boolean,
      default: false,
    },
    hideType: {
      type: Boolean,
      default: false,
    },
    showUpdateOption: {
      type: Boolean,
      default: false,
    },
  },
  async mounted() {
    this.id = this.$route.query.id;
    await this.getTypeList();
    this.swiperTypeList = this.items;
    this.$nextTick(() => {
      this.setTypeList();
      if (this.id) {
        this.setSwiperIndex(); // Set index and scroll to it
      }
    });
  },
  data() {
    return {
      active: 0,
      id: null,
      params: {
        type: 3,
        state: "",
      },
      swiperTypeList: [],
      selectedIndex: 0,
      saveSelected: { 0: "", 1: 1 },
      show: false,
      items: [
        { id: 1, name: "二氧化硅" },
        { id: 2, name: "高性能聚合物" },
        { id: 3, name: "特种聚合物" },
        { id: 4, name: "电动汽车电池" },
        { id: 5, name: "活性氧化物" },
        { id: 6, name: "聚氨酯" },
        { id: 7, name: "交联剂" },
        { id: 8, name: "涂料添加剂" },
        { id: 9, name: "动物营养" },
        { id: 10, name: "医药健康" },
        { id: 11, name: "护理化学品" },
      ],
      items2: [
        { id: 1, name: "待开始" },
        { id: 2, name: "进行中" },
        { id: 3, name: "已结束" },
      ],
    };
  },

  methods: {
    scrollToIndex(index) {
      this.$nextTick(() => {
        const container = this.$el.querySelector(".scroll-container");
        const items = this.$el.querySelectorAll(".scroll-item");
        const item = items[index - 1]; // Get the specific item
        if (!item) return; // Handle if item is not found

        const containerRect = container.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        const containerScrollLeft = container.scrollLeft;
        const scrollPosition =
          itemRect.left - containerRect.left + containerScrollLeft;

        container.scrollLeft = scrollPosition;
      });
    },

    async getTypeList() {
      let params = {
        "filter[type]": this.params?.type,
        "filter[state]": this.params.state,
      };
      let { data } = await this.$http.get("/api/platform/type", {
        params: params,
      });
      this.items = data.data;
    },
    onClick() {
      this.$emit("update", { type: this.active, ids: this.saveSelected });
      if (this.id) {
        this.saveIdsetTypeList();
      } else {
        this.setTypeList();
      }
    },
    setSwiperIndex() {
      this.id = this.$route.query.id;

      if (this.id) {
        this.saveSelected[this.active] = this.id;
        const itemIndex = this.swiperTypeList.findIndex(
          (item) => item.id == this.id
        );
        if (itemIndex !== -1) {
          this.selectedIndex = itemIndex;
        } else {
          this.selectedIndex = 0;
        }
        this.$nextTick(() => {
          this.scrollToIndex(this.selectedIndex + 1); // Scroll to selected index
        });
      }
    },
    moreListHandle() {
      this.$dataStatistics({ event_type: "click", page_title: "查看更多" });
      this.$router.push(`/moreList`);
    },
    isShowMore() {
      return this.showMore && !this.active;
    },
    isHideType() {
      return this.hideType && !this.active;
    },
    popItemHandle(index, item) {
      this.show = false;
      this.selectSlide(index, item);
      this.$nextTick(() => {
        this.scrollToIndex(index + 1);
      });
    },
    setTypeList() {
      if (this.isHideType()) return (this.swiperTypeList = []);
      if (this.active == 0) {
        this.swiperTypeList = this.items;
      } else {
        this.swiperTypeList = this.items2;
      }
      this.selectedIndex = 0;
      this.$nextTick(() => {
        this.scrollToIndex(this.selectedIndex); // Initialize scrolling position
      });
    },
    saveIdsetTypeList() {
      if (this.active == 0) {
        this.swiperTypeList = this.items;
      } else {
        this.swiperTypeList = this.items2;
      }
      let index = this.saveSelected[this.active];
      let itemIndex = this.swiperTypeList.findIndex((item) => item.id == index);
      if (itemIndex == -1) itemIndex = 0;
      this.selectedIndex = itemIndex;
      this.$nextTick(() => {
        this.scrollToIndex(itemIndex + 1); // Scroll to saved index
      });
    },
    selectSlide(index, sItem) {
      this.selectedIndex = index;
      this.saveSelected[this.active] = sItem.id;
      this.$dataStatistics(
        { event_type: "click", page_title: "分类切换" },
        JSON.stringify({
          title: `${sItem.name}`,
          id: sItem.id,
          type: this.active,
        })
      );
      if (this.id) {
        this.$emit("updateSelected", this.saveSelected);
      } else {
        this.$emit("updateSelected", {
          id: sItem.id,
          content: sItem.name,
          type: this.active,
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.scroll-container {
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  width: 100%;
  height: 100%;
}

.scroll-wrapper {
  display: flex;
}
.scrollType2{
  width: 100%;
  justify-content: space-around;
}

.scroll-item {
  display: inline-block;
  text-align: center;
  line-height: 86px;
  font-size: 28px;
  color: #a59c94;
  cursor: pointer;
  // width: 252px; /* 每行显示三个项目 */
  box-sizing: border-box;
  padding: 0 28px;
}

.scroll-item.active {
  color: #000000;
  font-weight: bold;
}

.moreIcon {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  img {
    width: 10px;
    height: 14px;
  }
}

.moreText {
  color: rgba(0, 0, 0, 0.6);
  font-size: 28px;
  display: flex;
  justify-content: flex-end;
  margin: 30px 35px 30px 0;
}
.popupContent {
  position: relative;
  padding: 54px 55px;
  width: 367px;
  height: 100vh;
  background: #ffffff;
  display: flex;
  flex-flow: column;
  justify-content: space-around;
  .closePop {
    width: 120px;
    height: 50px;
    background: #991d85;
    border-radius: 25px;
    font-size: 28px;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .title {
    font-size: 38px;
    color: #101010;
  }
  .list {
    margin-top: 10px;
    height: 1000px;
    overflow-y: scroll;
    overflow-x: hidden;
    .item {
      font-size: 30px;
      color: #101010;
      margin-bottom: 60px;
    }
    .active {
      color: #991d85;
    }
  }
}
::v-deep .van-tabs__wrap {
  background: #ffffff;
  box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.05);
  border: 1px solid #e4e1df;
}
::v-deep .van-tab {
  font-size: 30px;
}
::v-deep .van-tabs__line {
  background: #991d85;
}
.tabChildBox {
  background: #ffffff;
  width: 100%;
  .swiperBox {
    width: 756px;
    height: 86px;
    margin: 0 auto;

    // .moreIcon {
    //   width: 10px;
    //   height: 17px;
    //   display: flex;
    //   margin-right: 10px;
    //   img {
    //     width: 100%;
    //     height: 100%;
    //   }
    // }
  }
}
</style>
